export default "__VITE_ASSET__vmXtuMCd__"